import { forceLogout, showError } from '@redux/actions';
import { store } from '@redux/store';
import AxiosDefault, { AxiosRequestConfig, HttpStatusCode } from 'axios';
import { Configs, Enums } from '../constants';

class Axios {
  private axiosInstance = AxiosDefault.create({
    baseURL: Configs.BASE_URL,
    timeout: Configs.REQUEST_TIMEOUT,
  });

  constructor() {
    this.axiosInstance.interceptors.request.use(
      (config) => {
        const accessToken = store.getState().auth.jwt;
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
      },
      (error) => {
        // handle request error
        return Promise.reject(error);
      },
    );

    this.axiosInstance.interceptors.response.use(
      (response) => {
        // handle response data
        return response;
      },
      (error) => {
        // handle response un-authen error
        switch (error.response.status) {
          case HttpStatusCode.BadRequest:
          case HttpStatusCode.NotFound: {
            const message = error.response.data.error.message;
            store.dispatch(showError({ message }));
            break;
          }
          case HttpStatusCode.Unauthorized:
          case HttpStatusCode.Forbidden:
            store.dispatch(forceLogout());
            break;
          default:
            store.dispatch(showError({ message: error.response.status }));
            break;
        }
        return Promise.reject(error);
      },
    );
  }

  request<T>(
    method: Enums.HTTP_METHOD,
    path: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ) {
    switch (method) {
      case Enums.HTTP_METHOD.POST:
        return this.axiosInstance.post<T>(path, data, config);
      case Enums.HTTP_METHOD.PUT:
        return this.axiosInstance.put<T>(path, data, config);
      case Enums.HTTP_METHOD.DELETE:
        return this.axiosInstance.delete<T>(path, config);
      case Enums.HTTP_METHOD.PATCH:
        return this.axiosInstance.patch<T>(path, data, config);
      case Enums.HTTP_METHOD.GET:
      default:
        return this.axiosInstance.get<T>(path, config);
    }
  }
}

const axios = new Axios();

export default axios;
